const deliveryInformation = ({ showChristmanDeliveryScheduleButton }) => {
  return {
    deliveryOrCollection: {
      title: "Delivery & Collection",
      options: [
        ...(showChristmanDeliveryScheduleButton
          ? [
              {
                buttonLabel: "Christmas delivery schedule",
                url: "/delivery-information/christmas-delivery-schedules ",
              },
            ]
          : []),
        {
          buttonLabel: "Track an order",
          url: "https://account.johnlewis.com/track-order",
        },
        {
          buttonLabel: "Delivery restrictions",
          url: "https://www.johnlewis.com/customer-services/delivery-information/restrictions",
        },
        {
          buttonLabel: "Standard Delivery",
          url: "/delivery-information/uk-delivery",
        },
        {
          buttonLabel: "Next and Named day delivery",
          url: "/delivery-information/faster-and-timed-deliveries",
        },
        {
          buttonLabel: "Delivery by our approved suppliers",
          url: "/delivery-information/delivery-by-our-approved-suppliers",
        },
        {
          buttonLabel: "Click & Collect",
          url: "/delivery-information/click-and-collect",
        },
      ],
    },
  };
};

export default deliveryInformation;
